import React from 'react'

import './Title.scss'

const Title = ({ title }) => <h2 className='text-center header__title pb-lg-5 pb-3'>{title}</h2>

export default Title
